var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-center pt-2"},[_vm._v("La tua pre-iscrizione è andata a buon fine")])}
var staticRenderFns = []

export { render, staticRenderFns }